const { NIMBUS_DATA_TYPES } = require('../nimbus-data-types');

module.exports = {
  displayName: 'Picklist Validation',
  description: 'Picklist Validation With Master',
  sortOrder: 1,
  name: 'pickListValidationWithMaster',
  documentKey: 'pick_list_validation_with_master',
  values: {
    material: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Material',
      documentKey: 'material',
    },
    consignees: {
      dataType: NIMBUS_DATA_TYPES.BOOLEAN,
      defaultValue: false,
      displayName: 'Consignees',
      documentKey: 'consignees',
    },
  },
};
